<template>
  <div class="section has-text-centered user-avatar">
    <slot></slot>
    <h2 class="title is-5 has-text-weight-normal has-text-white">{{ name }}</h2>
    <h4 class="has-text-white">{{ companyName }} / {{ jobPosition }}</h4>
    <h4 class="title is-6 has-text-white has-text-weight-normal">
      {{ city }} / {{ country }}
    </h4>
    <div class="circular--portrait container">
      <a @click="$router.push({ name: 'admin.settings' })">
      <img
        
        class="is-user-avatar"
        :src="userAvatar"
        v-img-fallback="imgFallback"
      />
      </a>
    </div>
  </div>
</template>

<script>
import { ImgFallback } from 'v-img-fallback'
import { mapGetters } from 'vuex'
export default {
  name: 'UserAvatar',
  props: {},
  directives: {
    ImgFallback
  },
  computed: {
    ...mapGetters('user', [
      'name',
      'companyName',
      'jobPosition',
      'city',
      'country',
      'userAvatar'
    ])
  },
  data() {
    return {
      imgFallback: {
        error:
          'https://icon-library.com/images/default-user-icon/default-user-icon-4.jpg'
      }
    }
  }
}
</script>

<style scoped>
.circular--portrait {
  position: relative;
  width: 100px;
  height: 100px;
  overflow: hidden;
  border-radius: 50%;
  margin-bottom: -70px;
}

.circular--portrait img {
  width: 100%;
  height: auto;
}
.section {
  padding: 20px;
}

a:hover {
  color: var(--verde-dark-eco);
  transition: 0.3s;
}
</style>
